export const types = {
  GET_BUSINESS_CONSTANTS: 'COMMON/GET_BUSINESS_CONSTANTS',
  SET_BUSINESS_CONSTANTS: 'COMMON/SET_BUSINESS_CONSTANTS',
};

export const initialState = {
  constants: null,
};

const Common = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_BUSINESS_CONSTANTS:
      return {
        ...state,
        constants: action.data,
      }
    default:
      return { ...state };
  }
};

export const actions = {
  getBusinessConstants: () => ({ type: types.GET_BUSINESS_CONSTANTS }),
  setBusinessConstants: data => ({ type: types.SET_BUSINESS_CONSTANTS, data }),
};

export default Common;
